import { Injectable } from "@angular/core";
import { BaseProvider } from "../BaseProvider";
import { Router, NavigationExtras } from "@angular/router";
import { Http } from "@angular/http";
import { GlobalService } from "../../_global/global.service";

@Injectable()
export class PartnerService extends BaseProvider {
    resource = "partners";
    forgotresource = "partners";
    resourceLead = "partnerleads";
    getPartnersFilterUrl = "getPartners";

    // public notify = new Subject<any>();

    constructor(
        private http: Http,
        private router: Router,
        private _gs: GlobalService,
    ) {
        super(http);
    }
    getPartner() {
        // Fetch all Partner given the token
        return this.makeGetCall("partnersShortSnippet");
    }

    postBulkUpload(bulkRequest: any, getSampleFile) {
        return this.makeUploadCall(
            "uploadBulkPartner" + "?getSampleFile=" + getSampleFile,
            bulkRequest,
        );
    }

    getFilteredOrders(
        partnerType,
        wsflReferenceBranchId,
        partnerStatus,
        startDate,
        endDate,
    ) {
        if (
            partnerType != -1 &&
            wsflReferenceBranchId != -1 &&
            partnerStatus != -1
        ) {
            const url: string =
                this.getPartnersFilterUrl +
                "?endDate=" +
                endDate +
                "&wsflReferenceBranchId=" +
                wsflReferenceBranchId +
                "&partnerStatus=" +
                partnerStatus +
                "&startDate=" +
                startDate +
                "&partnerType=" +
                partnerType;
            return this.makeGetCall(url);
        } else if (wsflReferenceBranchId != -1 && partnerType != -1) {
            const url: string =
                this.getPartnersFilterUrl +
                "?endDate=" +
                endDate +
                "&wsflReferenceBranchId=" +
                wsflReferenceBranchId +
                "&partnerType=" +
                partnerType +
                "&startDate=" +
                startDate;
            return this.makeGetCall(url);
        } else if (wsflReferenceBranchId != -1 && partnerStatus != -1) {
            const url: string =
                this.getPartnersFilterUrl +
                "?endDate=" +
                endDate +
                "&wsflReferenceBranchId=" +
                wsflReferenceBranchId +
                "&partnerStatus=" +
                partnerStatus +
                "&startDate=" +
                startDate;
            return this.makeGetCall(url);
        } else if (partnerType != -1 && partnerStatus != -1) {
            const url: string =
                this.getPartnersFilterUrl +
                "?endDate=" +
                endDate +
                "&partnerType=" +
                partnerType +
                "&partnerStatus=" +
                partnerStatus +
                "&startDate=" +
                startDate;
            return this.makeGetCall(url);
        } else if (wsflReferenceBranchId != -1) {
            const url: string =
                this.getPartnersFilterUrl +
                "?endDate=" +
                endDate +
                "&startDate=" +
                startDate +
                "&wsflReferenceBranchId=" +
                wsflReferenceBranchId;
            return this.makeGetCall(url);
        } else if (partnerStatus != -1) {
            const url: string =
                this.getPartnersFilterUrl +
                "?endDate=" +
                endDate +
                "&partnerStatus=" +
                partnerStatus +
                // '&branchId=' + branchId +
                "&startDate=" +
                startDate;
            return this.makeGetCall(url);
        } else if (partnerType != -1) {
            const url: string =
                this.getPartnersFilterUrl +
                "?endDate=" +
                endDate +
                "&partnerType=" +
                partnerType +
                // '&branchId=' + branchId +
                "&startDate=" +
                startDate;
            return this.makeGetCall(url);
        } else {
            const url: string =
                this.getPartnersFilterUrl +
                "?endDate=" +
                endDate +
                "&startDate=" +
                startDate;
            return this.makeGetCall(url);
        }
    }
    getPartnerId(partnerId) {
        // Fetch a particular Partner details given the id
        return this.makeGetCall(this.resource + "/" + partnerId + "?scope=full");
    }
    addPartner(PartnerRequest: any) {
        // Add an Partner  given the Partner details
        return this.makePostCall(this.resource + "?scope=full", PartnerRequest);
    }

    addPartnerLeadCreate(PartnerRequest: any) {
        // Add an Partner  given the Partner details
        return this.makePostCall(this.resourceLead, PartnerRequest);
    }

    sentNotificationMail(leadID: any) {
        // Add an Partner  given the Partner details
        return this.makeGetCall(
            this.resourceLead + "/" + leadID + "/mailNotification",
        );
    }

    forgotPassword(forgotRequest: any) {
        // Make Forgot password flow
        return this.makePostCall(
            this.forgotresource + "/current/resetPassword",
            forgotRequest,
        );
    }

    setPasswordwithOTP(setPasswordModel: any) {
        // Set an Partner password
        return this.makePostCall(
            this.forgotresource + "/current/password",
            setPasswordModel,
        );
    }

    updatePasswordwithOTP(setPasswordModel: any) {
        // Update an Partner password
        return this.makePatchCall(
            this.forgotresource + "/current/password",
            setPasswordModel,
        );
    }

    uploadDocument(uploadRequest: any, partnerId: string) {
        // Update an Partner Document
        return this.makeUploadCall(
            this.resource + "/" + partnerId + "/photo",
            uploadRequest,
        );
    }
    uploadDocumentPost(uploadRequest: any, partnerId: string) {
        // Update an Partner ProfilePic
        return this.makeUploadCallPost(
            this.resource + "/" + partnerId + "/photo",
            uploadRequest,
        );
    }

    editPartner(Partner) {
        // TODO: to be removed from here
        const navigationExtras: NavigationExtras = {
            queryParams: {
                id: Partner.id,
            },
        };
        this.router.navigate(["/admin/partner/edit"], navigationExtras);
    }
    updatePartner(Partner, partnerId) {
        // Update an Partner  given the updated Partner details
        return this.makePatchCall(this.resource + "/" + partnerId, Partner);
    }
    // Issuers active in the global card product configuration: ["WSFXGPMCC", ...]
    getCardProductIssuers() {
        return this.makeGetCall("cardProducts/issuers");
    }
    // FXC settings: { isFXC, fxcPartnerId, issuers }
    updateFxcSettings(partnerId, fxcSettings) {
        return this.makePutCall(this.resource + "/" + partnerId + "/fxcSettings", fxcSettings);
    }
    deletePartner(partnerId) {
        // Delete an Partner given the Partner id
        return this.makeDeleteCall(this.resource + "/" + partnerId);
    }

    getCities() {
        return this.makeGetCall("cities");
    }

    getPartnerInvoiceList(partnerId) {
        return this.makeGetCall(this.resource + "/invoice/" + partnerId);
    }
    getPartnerInvoiceListWithDate(partnerId, toDate) {
        return this.makeGetCall(
            this.resource + "/invoice/" + partnerId + "?toDate=" + toDate,
        );
    }
    generatePartnerInvoice(partnerId, toDate) {
        return this.makeGetCall(
            this.resource + "/generateInvoice/" + partnerId + "?toDate=" + toDate,
        );
    }
    initiatePartnerInvoice(partnerId, toDate) {
        return this.makeGetCall(
            this.resource + "/initiateInvoice/" + partnerId + "?toDate=" + toDate,
        );
    }
    verifyInvoiceOTP(partnerId, initiationId, otp) {
        return this.makeGetCall(
            this.resource +
            "/validatePartnerInvoiceOtp/" +
            partnerId +
            "?initiationId=" +
            initiationId +
            "&otp=" +
            otp,
        );
    }

    uploadPartnerLogo(partnerId, uploadRequest) {
        return this.makeUploadCall(
            "partners/" + partnerId + "/logo",
            uploadRequest,
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/partner/partner.service.ts